import React from 'react'

import { Icon, Icons } from 'src/chrome'

import styles from './tooltip.module.scss'

enum Size {
  SMALL = 100,
  MEDIUM = 150,
  LARGE = 250,
  XL = 350,
}

type TooltipProps = {
  message: string
  hoverIcon: Icons
  iconSize?: number
  iconColor?: string
  pulsingIcon?: boolean
  position?: 'top' | 'bottom' | 'left' | 'right'
  size?: Size
  children?: React.ReactNode
}

const Tooltip: React.FC<TooltipProps> = props => {
  const {
    message,
    hoverIcon,
    iconSize,
    iconColor,
    children,
    pulsingIcon = false,
    position = 'top',
  } = props
  return (
    <div className={styles.container}>
      <span
        className={pulsingIcon ? `${styles.pulse} ${styles.icon}` : styles.icon}
      >
        <Icon icon={hoverIcon} size={iconSize || 15} color={iconColor} />
      </span>
      <div className={`${styles.tooltip} ${styles[position]}`}>
        <p className={styles.message}>{message}</p>
        {children}
      </div>
    </div>
  )
}

export default Tooltip
